import { FieldCode } from "@root/search/models/display-fields.constant";
import { ADDRESS_TYPE } from "@store/labels/labels.model";
import { DataElement } from "@store/user/user.model";
import { ColDef } from "ag-grid-community";

export const DATA_ELEMENTS_FOR_EXPORT: { [key: string]: Array<Partial<DataElement>> } = {
    [ADDRESS_TYPE.TAXBILLING]: [
        {
            fieldCode: FieldCode.OWNER_NAME_1,
            label: 'Owner',
            displayInfo: {
                renderId: 1,
                formatId: 14,
            },
        },
        {
            fieldCode: FieldCode.MAILING_ADDRESS,
            label: 'Tax Billing Address',
            displayInfo: {
                renderId: 1,
                formatId: 14,
            },
        },
        {
            fieldCode: FieldCode.MAILING_CITY_STATE,
            label: 'Tax Billing City & State',
            displayInfo: {
                renderId: 0,
                formatId: 29,
            },
        },
        {
            fieldCode: FieldCode.MAILING_ZIP,
            label: 'Tax Billing Zip'
        },
    ],
    [ADDRESS_TYPE.ADDRESS]: [
        {
            fieldCode: FieldCode.OWNER_NAME_1,
            label: 'Owner',
            displayInfo: {
                renderId: 1,
                formatId: 14,
            },
        },
        {
            fieldCode: FieldCode.SITE_ADDRESS,
            label: 'Site Address (781)',
            displayInfo: {
                renderId: 0,
                formatId: 107,
            },
        },
        {
            fieldCode: FieldCode.PROPERTY_CITY_NAME,
            label: 'City (19)3',
            displayInfo: {
                renderId: 0,
                formatId: 14,
            },
        },
        {
            fieldCode: FieldCode.PROPERTY_STATE_NAME,
            label: 'State',
            displayInfo: {
                renderId: 0,
                formatId: 8,
            },
        },
        {
            fieldCode: FieldCode.PROPERTY_ZIP_CODE,
            label: 'Zip Code',
        },
    ]
}

export const COLUMN_DEFS: { [key: string]: Array<ColDef> } = {
    [ADDRESS_TYPE.TAXBILLING]: [
        {
            field: 'INDEX',
            headerName: '',
            width: 50,
        },
        {
            field: FieldCode.OWNER_NAME_1,
            headerName: 'Owner Name #',
        },
        {
            field: FieldCode.MAILING_ADDRESS,
            headerName: 'Tax Billing Address #',
        },
        {
            field: FieldCode.MAILING_CITY_STATE,
            headerName: 'Tax Billing City & State #',
        },
        {
            field: FieldCode.MAILING_ZIP,
            headerName: 'Tax Billing Zip #',
        },
    ],
    [ADDRESS_TYPE.ADDRESS]: [
        {
            field: 'INDEX',
            headerName: '',
            width: 50,
        },
        {
            field: FieldCode.OWNER_NAME_1,
            headerName: 'Owner Name #',
        },
        {
            field: FieldCode.SITE_ADDRESS,
            headerName: 'Site Address #',
        },
        {
            field: FieldCode.PROPERTY_CITY_NAME,
            headerName: 'City #',
        },
        {
            field: FieldCode.PROPERTY_STATE_NAME,
            headerName: 'State #',
        },
        {
            field: FieldCode.PROPERTY_ZIP_CODE,
            headerName: 'ZIP Code #',
        },
    ]
}
